import styled from 'styled-components';
import theme from '@styles/theme';

export const Wrapper = styled.div`
    margin: 150px auto;
    width: 343px;
`;
export const Title = styled.h2`
    margin-bottom: 20px;
    font-size: 24px;
    font-family: PretendardMedium, sans-serif;
    text-align: center;
`;
export const SubTitle = styled.div`
    margin-bottom: 40px;
    font-size: 14px;
    color: ${theme.colors.grayIconColor};
    text-align: center;
`;
